export type ForexService = {
  id: number;
  title: string;
  activeTab: string;
};

const ForexServices: ForexService[] = [
  {
    id: 1,
    title: 'Buy Forex',
    activeTab: 'BUY',
  },
  {
    id: 2,
    title: 'Sell Forex',
    activeTab: 'SELL',
  },

  {
    id: 3,
    title: 'Send Money Abroad',
    activeTab: 'ABROAD',
  },
  {
    id: 4,
    title: 'Reload Forex Card',
    activeTab: 'RELOAD',
  },
  {
    id: 5,
    title: 'Unload Forex Card',
    activeTab: 'UNLOAD',
  },
];

export default ForexServices;
